import React, {useState, useEffect} from 'react';
import NavigationBar from '../../ReusableComp/NavigationBar';
import NavBarLeft from '../../ReusableComp/NavBarLeft';
import { useDispatch, useSelector } from 'react-redux';
import {getStudyData } from '../../../Redux/actions/actions';
import axios from "../../../axios-interceptor";
import { base_url } from "../../../utilities";
import PopUpModal from "../../ReusableComp/PopUpModal";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import { useNavigate } from "react-router";
import Loader from '../../ReusableComp/Loader';


const  PMSAdminAddMR = () => {
    const navigate = useNavigate();

    const registrationSteps = [
        {
            stepTitle: "1. Medical Reviewer Details",
            description:"Age, Sex, Phone etc."
        },
        {
            stepTitle: "2. Study Details",
            description:"Hospital and Dose Information"
        },
        {
            stepTitle: "3. Preview and Confirm",
            description:"Final confirmation"
        },
        
    ];

    const dispatch = useDispatch();
    const [regStep, setRegStep] = useState(1);
    const [mrName, setQrName] = useState("");
    const [mrEmail, setQrEmail] = useState("");
    const [bbilEmployeeId, setBbilEmployeeId] = useState("");
    const [open, setOpen] = React.useState(false);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const studyData = useSelector((state) => (state.studyData))
    const [studyIds, setStudyIds] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if(!localStorage.getItem("login_user_name")){
            navigate("/");
        }
    }, []);
 
    useEffect(() => {
        dispatch(getStudyData());
    }, [dispatch]);
    const sampar = [];
    

    const handleStepChange = (val) => {
        if(val > 0 && regStep<3){
            let shift = regStep + val
            setRegStep(shift);
        }
        if(val < 0 && regStep > 1){
            let shift = regStep + val
            setRegStep(shift);
        }
        
    }
 
    const handleChange = (selected) => {
        selected.map((item) => {sampar.push(item.value.study_id)})
        setSelectedOptions(selected);
        setStudyIds(sampar);
      };

    const createNewQR = () => {
        let medical_reviewer_object = 
            {
                name: mrName,
                email: mrEmail,
                bbil_employee_id: bbilEmployeeId,
                study_id: studyIds,
                created_by:localStorage.getItem('login_user_name')
            }
           
        ;
        setLoading(true);
        axios
          .post(base_url + "medical-reviewer/create_medical_reviewer", medical_reviewer_object)
          .then((res) => {
                setLoading(false);
            if(res.data.data.errors){
            if(res.data.data.errors[0].message === "email must be unique"){
                toast.error('The user has already been created with the given email.', {
                  toastId: 1
                })
              }
            }
              else{
            setOpen(true);
            // handleCloseModal();
          }
          })
          .catch((err) => {
            console.log(err);
          });
      };


    const viewProfile =() => {
        window.location.replace("/mrlist")
      }
    const handleClosePopup = () => {
        setOpen(false);
        navigate("/mrlist")
        window.location.reload();
      };

    const handleQrNameChange = (event) => {
        const inputValue = event.target.value;
        const regex = /^[A-Za-z\s.]+$/; // Only alphabetic characters allowed

        if (regex.test(inputValue) || inputValue === '') {
            setQrName(event.target.value);
        }
      };

const [ispiEmailValid, setIsPiEmailValid] = useState(true)
    const handleQrEmailChange = (event) => {
        // setQrEmail(event.target.value);
        const input = event.target;
        const isValid = input.checkValidity();
        setIsPiEmailValid(isValid);
        setQrEmail(input.value);
        
        };
    

     
    function convertToTitleCase(str) {
        return str.replace(/\w\S*/g, function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }
  
    const handlePQrMrcNumberChange = (event) => {
        setBbilEmployeeId(event.target.value);
        };
        const maxDate = new Date().toISOString().split('T')[0];
    
        const customDropdownIndicator = () => null;
      
    return (
        <>
        <div>
            <NavigationBar studyDropdwn={true} title={"Medical Reviewer"}/>
            <div className='main_body registration_steps_main'>
            <div className='row flex-nowrap' >
                    <div className="col-lg-3 qr_left_content" >
                        <div className='lableSteps'>
                            <span >Registration Steps</span>
                        </div>
                        
                        {registrationSteps?.map((step, index) => {
                            return (
                                <div
                                key={index}
                                  className={`${
                                    regStep === index + 1 ? "selectedTabStyl" : ""
                                  }`}
                                >
                                <div className={`my-div ${regStep === index+1 ? 'registration_steps_selected' : 'registration_steps'}`} key={index}>
                                    <span>{step.stepTitle}</span>
                                    <span className='registration_description'>{step.description}</span>
                                </div>
                                </div>
                            );
                            })}
                    </div>
                    <div className="col  qr_prvw_cnfrm">
                        <div className='lableContent'>
                            <span >{registrationSteps[regStep-1].stepTitle}</span>
                            <span >{regStep} of 3</span>
                        </div>
                        {regStep === 1 && 
                        <div className='med_rev_1st'>
                            <div className='piDetilsRow'>
                                <div className='piDetilsItems'>
                                    <label htmlFor="mrName">Name<span style={{color:"red"}}>*</span></label>
                                    <input
                                        value={mrName}
                                        className="customInput"
                                        id='mrName'
                                        type='text'
                                        placeholder='Full Name'
                                        aria-placeholder='#D4D4D4'
                                        style={{padding:"16px 12px", width:"380px"}}
                                        onChange={handleQrNameChange}
                                    />
                                </div>
                                  <div className='piDetilsItems '>
                                        <label htmlFor="piEmail">Email<span style={{ color: "red" }}>*</span></label>
                                        <input
                                            className="customInput"
                                            value={mrEmail}
                                            id='piEmail'
                                            type='email'
                                            name='piEmail'
                                            placeholder='email@gmail.com'
                                            aria-placeholder='#D4D4D4'
                                            style={{padding:"16px 12px", width:"380px"}}
                                            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                                            required
                                            onChange={handleQrEmailChange}
                                        />
                                        {!ispiEmailValid && <p className='errormsg' >Invalid email format</p>}
                                    </div>   
                            </div>

                            <div className='piDetilsRow'>
                            <div className='piDetilsItems'>
                                    <label htmlFor="bbilEmployeeId">BBIL Employee Id <span style={{color:"red"}}>*</span></label>
                                    <input
                                        value={bbilEmployeeId}
                                        className="customInput"
                                        id='bbilEmployeeId'
                                        type='text'
                                        placeholder='Enter Here'
                                        aria-placeholder='#D4D4D4'
                                        style={{padding:"16px 12px", width:"380px"}}
                                        onChange={handlePQrMrcNumberChange}
                                    />
                                </div>
                             
                            </div>
                            
                        </div>}
                        {regStep === 2 && 
                            <div style={{minHeight:"66vh", overflowY: "auto", background:"white"}} >
                                <div  style={{ margin: '32px', display:"flex", flexDirection:"column", textAlign:"start" }}>
                                <label htmlFor="piStudy">Select Study<span style={{color:"red"}}>*</span></label>
                                <Select
                                    id="piStudy"

                                    isMulti
                                    options={studyData?.map((item) => ({
                                        value: item,
                                        label: `${item.study_name}`,
                                        
                                      }))}
                                    value={selectedOptions}
                                    onChange={handleChange}
                                    className='custom_select_main'
                                    placeholder="Select Study from the options"
                                    //  styles={customStyles}
                                    styles={{
                                        control: (provided, state) => ({
                                          ...provided,
                                         margin: 'auto',
                                          paddingRight:"25px" 
                                        }),
                                       }}
                                   components={{
                                        IndicatorSeparator: () => null, 
                                     DropdownIndicator: customDropdownIndicator,
                                     ClearIndicator: () => null,
                                        
                                 }}
                                />
                                </div>
                        </div>}
                        {regStep === 3 && 
                            <div className='prev_container' style={{ background:"white"}}>
                               
                                <div style={{border:"1px dotted #E1E5E7", marginLeft:"32px", marginRight:"24px"}}></div>
                                <div style={{ display: "flex", flexDirection: "row", margin: "24px 32px 0px 32px", justifyContent: "space-evenly", color: "black" }}>
                                    <p style={{ fontWeight: "bold", color: "black" }}>
                                        {mrName}
                                        <img style={{ height: "20px", margin: "6px", paddingLeft: "5px" }} />
                                    </p>
                                    <p>.</p>
                                    <p>
                                        {mrEmail}
                                        <img style={{ height: "20px", margin: "4px", paddingLeft: "5px" }} src="./images/icons/Mail Send Envelope by Streamlinehqmainemail.svg" alt="" />
                                    </p>
                                </div>
                                <div style={{border:"1px dotted #E1E5E7", marginLeft:"32px", marginRight:"32px"}}></div>
                                
                                    {selectedOptions &&
                                    
                                    selectedOptions?.map((item) => (
                                        <div style={{ margin: "14px 22px 0px 22px", backgroundColor: "#EAEAEA", borderRadius: "8px", padding: "10px" }}>
                                        <p style={{ padding: "20px 20px 10px 20px", color: "black", fontWeight: "bold" }}>{item.value.product_name}</p>
                                        <div style={{ border: "1px dotted #E1E5E7" }}></div>
                                        <div className="d-flex ms-3">
                                            <div className="col-3">
                                            <p>Study Name</p>
                                            </div>
                                            <div className="col-9">
                                            <p style={{ color: "black", fontWeight: "bold" }}>{item.value.study_name}</p>
                                            </div>
                                        </div>
                                        <div className="d-flex ms-3">
                                            <div className="col-3">
                                            <p>Number of Doses</p>
                                            </div>
                                            <div className="col-9">
                                            <p style={{ color: "black", fontWeight: "bold" }}>{item.value.number_of_doses}</p>
                                            </div>
                                        </div>
                                        <div className="d-flex ms-3">
                                            <div className="col-3">
                                            <p>Duration Between Doses</p>
                                            </div>
                                            <div className="col-9">
                                            <p style={{ color: "black", fontWeight: "bold" }}>{item.value.duration_between_doses} {item.value.duration_between_doses_type}</p>
                                            </div>
                                        </div>
                                        <div className="d-flex ms-3">
                                            <div className="col-3">
                                            <p>Dose of Administration</p>
                                            </div>
                                            <div className="col-9">
                                            <p style={{ color: "black", fontWeight: "bold" }}>{item.value.dose_of_administration}</p>
                                            </div>
                                        </div>
                                        <div className="d-flex ms-3">
                                            <div className="col-3">
                                            <p>Age Group</p>
                                            </div>
                                            <div className="col-9">
                                            <p style={{ color: "black", fontWeight: "bold" }}>{item.value.age_group}</p>
                                            </div>
                                        </div>
                                    </div>
                                    ))}
                                 
                                </div>
                            
                        }



                        <div className='registrationStepsFooter'>
                            {regStep > 1 &&
                                <button className="white_btn" onClick={() => handleStepChange(-1)} >Previous</button>
                            }
                            {regStep === 1 && 
                            <div className='d-flex'>
                               <button className="white_btn white_btn_back me-3" onClick={() => navigate("/mrlist")} >Back</button>

                                <button className="orange_btn" onClick={() => handleStepChange(1)}
                                    disabled={!(mrName !== "" && bbilEmployeeId !== "" &&
                                    mrEmail !== "" && ispiEmailValid)}
                                >Continue</button>
                            </div>
                            }
                            {regStep === 2 &&
                                <button 
                                disabled={selectedOptions.length === 0}
                                className="orange_btn" onClick={() => handleStepChange(1)}>Continue</button>
                            }
                            
                            {regStep === 3 &&
                                <button className="orange_btn px-4" onClick={createNewQR}>Done</button>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <PopUpModal
                handleClose={handleClosePopup}
                open={open}
                title={"Success!"}
                msg={convertToTitleCase(mrName)+ "'s Medical Reviewer profile has been created!"}
                close={"Close"}
                actionbtn={"Done"}
                onConfirm={viewProfile}
            />
        </div>
        {loading && <Loader />}
        
        </>
    )
}
export default PMSAdminAddMR; 